import type { Namespaces } from 'bundles/epic/__generated__/namespaces';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import type { MerchandisingHeroModuleFieldsFragment } from 'bundles/front-page/__generated__/contentfulTypes';

export const getRegionalExperiment = () => {
  const experimentNames = [
    'regional2024NYPromotionsGlobal',
    'regional2024NYPromotionsGermany',
    'regional2024NYPromotionsFrance',
    'regional2024NYPromotionsIndia',
    'regional2024NYPromotionsEmerging',
    'regional2024NYPromotionsLatam',
  ] as Array<keyof Namespaces['GrowthDiscovery']>;

  return experimentNames.find((name) => GrowthDiscoveryExperiments.get(name) === true);
};

export const getRegionName = (experimentName: keyof Namespaces['GrowthDiscovery']) => {
  switch (experimentName) {
    case 'regional2024NYPromotionsGlobal':
      return 'global';
    case 'regional2024NYPromotionsLatam':
      return 'latam';
    case 'regional2024NYPromotionsGermany':
      return 'germany';
    case 'regional2024NYPromotionsIndia':
      return 'india';
    case 'regional2024NYPromotionsFrance':
      return 'france';
    case 'regional2024NYPromotionsEmerging':
      return 'emerging';
    default:
      return '';
  }
};

export const getRegionalContent = (
  regionalHeroModules?: Array<MerchandisingHeroModuleFieldsFragment | null> | null,
  experimentName?: keyof Namespaces['GrowthDiscovery']
) => {
  if (!regionalHeroModules?.length || !experimentName) {
    return undefined;
  }

  return regionalHeroModules.find((module) => module?.region?.toLowerCase() === getRegionName(experimentName));
};
